












var _createStrictShapeTypeChecker=require('./createStrictShapeTypeChecker');var _createStrictShapeTypeChecker2=_interopRequireDefault(_createStrictShapeTypeChecker);
var _propTypes=require('prop-types');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}








var EdgeInsetsPropType=(0,_createStrictShapeTypeChecker2.default)({
top:_propTypes.number,
left:_propTypes.number,
bottom:_propTypes.number,
right:_propTypes.number});


module.exports=EdgeInsetsPropType;


// WEBPACK FOOTER //
// ./~/react-native-web/dist/propTypes/EdgeInsetsPropType.js